import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Page, PointOfSale, PointOfSaleForm } from '../models';

@Injectable()
export class PointOfSalesService {

    pointOfSalesUrl = environment.dns + 'api/pointOfSales/';

    constructor(private http: HttpClient) { }

    getPaginate(
      page: number,
      size: number,
      search: string = '',
      revendeurId: number = null
    ): Observable<Page<PointOfSale>> {

      let url =
        this.pointOfSalesUrl +
        'paginate?page=' + page +
        '&size=' + size +
        '&search=' + encodeURIComponent(search || '');

      if (revendeurId !== null && revendeurId !== undefined) {
        url += '&revendeurId=' + revendeurId;
      }

      return this.http.get<Page<PointOfSale>>(url);
    }

    getList(): Observable<PointOfSale[]> {
        return this.http.get<PointOfSale[]>(this.pointOfSalesUrl + 'list');
    }

    getOne(id: number): Observable<PointOfSale> {
        return this.http.get<PointOfSale>(this.pointOfSalesUrl + id);
    }

    add(pointOfSaleForm: PointOfSaleForm): Observable<PointOfSale> {
        return this.http.post<PointOfSale>(this.pointOfSalesUrl, pointOfSaleForm);
    }

    update(pointOfSaleForm: PointOfSaleForm): Observable<PointOfSale> {
        return this.http.put<PointOfSale>(this.pointOfSalesUrl, pointOfSaleForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.pointOfSalesUrl + id);
    }
}
